
<template>
   <b-container class="main-container">
      <h3>Add New Summer Pay Request</h3>

      <summer-pay-form id="spr-form" @submit="addSummerPayRequest"></summer-pay-form>
  </b-container>
</template>


<script>
import ToastrSettings from "../../settings/toastr-settings";
import toastr from "toastr";
import roleChecks from "../../misc/role-checks";

import SummerPayForm from "../../components/summer-pay/summer-pay-form";
import summerPayRequestApi from "../../api/summerPayRequests";

import { mapState, mapActions } from "vuex";

export default {
  mixins: [roleChecks],
  // name: "summerPayForm",       // do NOT add this line, it causes problems - confuses with component name

  data() {
    return {
      spForm: null
    };
  },
  components: {
    // widget: Widget,
    SummerPayForm
  },
  methods: {
    loadForm(spForm) {
      if (spForm) {
        this.form = _.clone(spForm);
      }
    },
    addSummerPayRequest(value) {

      summerPayRequestApi
      .postspRequest(value.form, value.files)
        .then(response => {
          this.$router.push({
            name: "PayRequestDetails",
            params: { id: response.data, files: value.files }
          });
          summerPayRequestApi.submittedEmail(response.data);
          toastr.options = ToastrSettings;
          toastr.success("The request has been saved.", "Success");
        });

    }
  }
};
</script>
